"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useSTCStatus = function (stcStatus) {
    var status = (0, react_1.useMemo)(function () {
        if (stcStatus === '0') {
            return 'STC No';
        }
        else if (stcStatus === '1') {
            return 'STC Yes';
        }
        else if (stcStatus === '2') {
            return 'STC Awaiting';
        }
    }, [stcStatus]);
    return status;
};
exports.default = useSTCStatus;
